module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Chat-smile-fbe1fc8f05d4a146805c07e3c743d7af.svg";